import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import styles from "./Logo.module.scss";

export const Logo = ({ className, color, width, height }) => {

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        className
    );

    return (
        <svg
            className={classes}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 326 61"
            width={width}
            height={height}
        >
            <defs/>
            <path
                fill={color}
                fillRule="evenodd"
                d="M265.889 4.966v50.068c0 3.311-1.655 4.966-4.966 4.966h-17.87c-3.311 0-4.966-1.655-4.966-4.966V4.966c0-3.311 1.655-4.966 4.966-4.966h17.87c3.311 0 4.966 1.655 4.966 4.966zM275.048 0h19.538c1.955.054 4.356.732 7.206 2.035 1.791.787 4.437 2.225 7.938 4.314V2.076c0-1.357.624-2.049 1.872-2.076h9.078c3.311 0 4.966 1.655 4.966 4.966v50.068c0 3.311-1.655 4.966-4.966 4.966h-19.621c-1.953-.081-4.355-.761-7.204-2.035-1.792-.787-4.438-2.226-7.938-4.315v4.274c0 1.357-.625 2.049-1.873 2.076h-8.996c-3.311 0-4.966-1.655-4.966-4.966V4.966C270.083 1.655 271.738 0 275.048 0zM136.934 40.908c-1.33 0-1.995.652-1.995 1.955v1.994c0 1.329.665 1.995 1.995 1.995h19.823c1.33 0 1.995-.666 1.995-1.995v-1.994c0-1.303-.665-1.955-1.995-1.955h-19.823zM160.625 60c-1.248-.027-1.872-.692-1.872-1.995v-1.994c0-1.303-.665-1.954-1.995-1.954h-19.823c-1.33 0-1.995.651-1.995 1.954v1.913c0 1.357-.624 2.049-1.873 2.076h-9.037c-3.311 0-4.966-1.655-4.966-4.966V4.966c0-3.311 1.655-4.966 4.966-4.966h45.631c3.311 0 4.966 1.655 4.966 4.966v50.068c0 3.311-1.655 4.966-4.966 4.966h-9.036zm35.821-13.147h19.824c1.329 0 1.993-.666 1.993-1.995v-1.994c0-1.303-.664-1.955-1.993-1.955h-19.824c-1.329 0-1.995.652-1.995 1.955v1.994c0 1.329.666 1.995 1.995 1.995zM4.966 0h45.631c3.311 0 4.966 1.655 4.966 4.966v50.068c0 3.311-1.655 4.966-4.966 4.966H4.966C1.655 60 0 58.345 0 55.034V4.966C0 1.655 1.655 0 4.966 0zm189.485 57.924c0 1.357-.624 2.049-1.872 2.076h-9.036c-3.311 0-4.967-1.655-4.967-4.966V4.966c0-3.311 1.656-4.966 4.967-4.966h45.631c3.311 0 4.966 1.655 4.966 4.966V43.23c-.108 3.094-1.764 4.641-4.966 4.641h-4.804c.651.569 2.755 1.736 6.31 3.5 2.28 1.14 3.433 2.32 3.46 3.541v.123c0 3.311-1.655 4.966-4.966 4.966h-19.579c-1.955-.081-4.356-.761-7.206-2.035-1.79-.787-4.437-2.226-7.938-4.315v4.273zM59.552 4.966C59.552 1.655 61.194 0 64.478 0h45.671c3.284 0 4.926 1.655 4.926 4.966v26.743c-.055 1.954-.733 4.356-2.036 7.206-.787 1.79-2.225 4.436-4.315 7.938h4.274c1.357 0 2.049.624 2.076 1.872v6.31c0 3.311-1.642 4.966-4.926 4.966h-45.67c-3.284 0-4.926-1.655-4.926-4.966v-1.588c.055-1.954.732-4.355 2.035-7.205.787-1.764 2.226-4.409 4.315-7.938h-4.274c-1.357 0-2.049-.624-2.076-1.873V4.966zM17.87 46.853h19.824c1.33 0 1.995-.666 1.995-1.995v-1.994c0-1.303-.665-1.955-1.995-1.955H17.87c-1.33 0-1.995.652-1.995 1.955v1.994c0 1.329.665 1.995 1.995 1.995z"
                clipRule="evenodd"
            />
        </svg>
    );
};
    
Logo.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
};

Logo.defaultProps = {
    color: "#EC5C52",
    width: 326,
    height: 61
};
    